import repository from '@/api'
import { PortletPermission } from '@/models/Portlet'

const URI = '/v1/portlets'
export default {
  registerPortlet(portlet) {
    return repository.post(`${URI}`, new PortletOfCreation(portlet))
  },
  findPortletById(portletId) {
    return repository.get(`${URI}/${portletId}`)
  },
  modifyPortlet(portletId, portlet) {
    return repository.patch(`${URI}/${portletId}`, new PortletOfModification(portlet))
  },
  removePortlet(portletId) {
    return repository.delete(`${URI}/${portletId}`)
  },
}

class PortletOfCreation {
  name?: string
  alias?: string
  portletNo?: string
  uiComponentName?: string
  parameters: { name: string; value: string }[] = []
  subsystemCode?: string
  permissions: PortletPermission[] = []
  enabled: boolean = false
  message?: string
  note?: string
  constructor(props) {
    Object.keys(this).forEach((k) => (this[k] = props[k]))
    this.subsystemCode = props.subsystem?.code
    this.parameters = this.parameters.filter(({ name }) => name)
    this.permissions = this.permissions.filter(({ scope, permissionKey }) => scope && permissionKey)
  }
}

class PortletOfModification extends PortletOfCreation {
  mockData?: string
  constructor(props) {
    super(props)
    delete this.portletNo
    this.mockData = props.mockData
  }
}
